import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
  width?: string;
}

const Crown: React.FC<CustomIconProps> = ({ width }) => (
  <svg
    width={width ?? '32'}
    height={width ?? '32'}
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.66666 25.3346H29.3333V28.0013H2.66666V25.3346ZM2.66666 6.66797L9.33333 10.668L16 2.66797L22.6667 10.668L29.3333 6.66797V22.668H2.66666V6.66797Z'
      fill='white'
    />
  </svg>
);

export default Crown;
